import { Link } from "react-router-dom";
import { styled } from "styled-components";

export const ListTitle = styled(Link)`
  font-size: 18px;
  color: #383838;

  text-decoration: none;
`;
